module.exports = __webpack_public_path__ + "static/media/logo3.f89bdfc0.png";